import styled, { css } from 'styled-components';
import { Button, Texter } from 'lego-dist';

export const WrapperSelecter = styled.div.attrs(() => ({
  className: 'WrapperSelecterMoveDirector',
}))`
  display: block;
  position: relative;
  height: 300px;
  margin-top: 5px;
`;


export const StylesAddDirectorWrapper = styled.div.attrs(() => ({
  className: 'StylesAddDirectorWrapper',
}))`
  width: 100%;
  height: calc(100vh - 60px);
  padding: 20px 16px;

  overflow-y: scroll;

  & form {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    height: 100%;
    .texter-error {
      color: #ef4b48;
      font-size: 14px;
      font-weight: normal;
      margin-bottom: 20px;
      margin-top: 5px;
    }
  }

  ${({ theme }) => theme.breakPoints.tablet} {
    height: auto;
    padding: 20px;
  }
`;

export const StylesGeneralInformationStepWraper = styled.div.attrs(() => ({
  className: 'StylesGeneralInformationStepWraper',
}))`
  height: 100%;
  width: 100%;

  ${({ theme }) => theme.breakPoints.tablet} {
    height: auto;
  }
`;

export const StylesPermissionsStepWraper = styled.div.attrs(() => ({
  className: 'StylesPermissionsStepWraper',
}))`
  height: 100%;
  width: 100%;

  .StylesAddDirectorContent p {
    margin-bottom: 20px;
  }

  ${({ theme }) => theme.breakPoints.tablet} {
    height: auto;
  }
`;

export const PreviousButton = styled(Button).attrs(() => ({
  color: 'secondary',
  small: true,
  rounded: true,
  outline: true,
}))``;

export const Content = styled.div.attrs(() => ({
  className: 'StylesAddDirectorContent',
}))`
  color: ${({ theme }) => theme.colors.darkGray};
  font-weight: bold;

  display: flex;
  flex-direction: column;
  justify-content: center;

  ${({ theme }) => theme.breakPoints.tablet} {
    margin-bottom: 10px;
  }
`;

export const ContentTitle = styled.h2.attrs(() => ({
  className: 'StylesAddDirectorContentTitle',
}))`
  color: #4A4A4A;
  font-size: 18px;
  font-weight: bold;
  line-height: 21px;
  margin: 0;
  margin-bottom: 5px;
  padding: 0;
`;

export const ContentSubtitle = styled.p.attrs(() => ({
  className: 'StylesAddDirectorContentSubtitle',
}))`
  color: ${({ theme }) => theme.colors.shadeDark};
  font-size: 14px;
  font-weight: normal;
  line-height: 18px;
  margin: 0;
  padding: 0;
`;

export const OptionPermissionsTabs = styled.div.attrs(({ className }) => ({
  className: `StylesAddDirectorOptionPermissionsTabs ${className}`,
}))`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  border: 1px solid #F77B5E;
  border-radius: 8px;
  height: 32px;
  max-width: 360px;
  overflow: hidden;
  margin-bottom: 20px;
`;

const OptionPermissionsTabsItemStyleActive = css`
  background-color: #F77B5E;
  color: ${({ theme }) => theme.colors.white};
`;

const ContentCustomPermissionsStyles = css`
  .StylesAddDirectorContentCheckbox {
    opacity: 1;
  }
`;

export const ContentCustomPermissions = styled.div.attrs(({ className }) => ({
  className: `StylesAddDirectorContentCustomPermissions ${className}`,
}))<any>`
  display: block;

  .StylesAddDirectorContentCheckbox {
    opacity: 0;
  }

  ${({ custom }) => custom && ContentCustomPermissionsStyles};
`;

export const CustomPermissionsListContainer = styled.div.attrs(() => ({
  className: 'CustomPermissionsListContainer',
}))`
  max-height: calc(100vh - 345px);
  overflow-y: auto;
  ${({ theme }: any) => `
    ${theme.breakPoints.tablet} {
      max-height: 225px;
    }
  `}
`;

export const SpecialPermissionsContainerContentCustomPermissions = styled.div.attrs(({ className }) => ({
  className: `StylesAddDirectorContentCustomPermissions ${className}`,
}))<any>`
  display: block;

  .StylesAddDirectorContentCheckbox {
    opacity: 0;
  }

  ${({ custom }) => custom && ContentCustomPermissionsStyles};
`;

export const OptionPermissionsTabsItem = styled.div.attrs(({ className }) => ({
  className: `StylesAddDirectorOptionPermissionsTabsItem ${className}`,
}))<any>`
  display: block;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
  color: #F77B5E;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ active }) => active && OptionPermissionsTabsItemStyleActive};
`;

export const InputGroup = styled.div.attrs(({ className }) => ({
  className: `StylesAddDirectorInputGroup ${className}`,
}))`
  display: block;
  margin-bottom: 16px;
  position: relative;

  .legoSelecterContainer {
    border-color: ${({ theme }) => theme.colors.shadeMedium};
    box-shadow: 0 3px 6px 0 #00000020;
  }

  .legoSelecterInput {
    color: #4A4A4A;
    font-size: 16px;
    font-weight: normal;
  }

  .legoSelecterLabel {
    color: ${({ theme }) => theme.colors.shadeMediumDark};
    font-size: 16px;
    font-weight: normal;
    line-height: 28px;
  }

  .legoSelecterCheckbox {
    height: 18px;
    width: 18px;

    border-radius: 3px;
    cursor: pointer;
  }

  .legoSelecterOptionsList .legoSelecterOptionItem {
    display: flex;
    align-items: center;

    height: 36px;
    padding: 0 16px;
  }

  .legoSelecterOptionsList .legoSelecterOptionItem:hover {
    background-color: ${({ theme }) => theme.colors.shadeLight};;
  }

  .legoSelecterOptionsContainer {
    border-color: ${({ theme }) => theme.colors.shadeMedium};
    box-shadow: 0 3px 6px 0 #00000020;
    margin-top: 0;
    max-height: 200px;
    overflow-y: auto;
    padding: 0;
  }

  .legoSelecterOptionIndicator {
    top: 12px;
  }

  .legoSelecterOptionsList {
    margin-top: 0;
  }
`;

export const InputGroupCheckbox = styled.div.attrs(({ className }) => ({
  className: `StylesAddDirectorInputGroupCheckbox ${className}`,
}))`
  display: grid;
  grid-template-columns: 1fr 30px;
  grid-gap: 24px;
  align-items: flex-start;

  .legoCheckBoxWrapper {
    margin-top: 0;
  }

  .StylesAddDirectorLabel {
    display: block;
    font-size: 14px;
    font-weight: 400;
  }

  .legoCheckboxElement:checked + .legoCheckboxLabel::before {
    background-color: #75B753;
    border-color: #75B753;
  }
`;

export const ContentCheckbox = styled.div.attrs(({ className }) => ({
  className: `StylesAddDirectorContentCheckbox ${className}`,
}))`
  display: block;
`;

export const InputGrid = styled.div.attrs(({ className }) => ({
  className: `StylesAddDirectorInputInputGrid ${className}`,
}))`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 16px;
`;

export const Label = styled.label.attrs(() => ({
  className: 'StylesAddDirectorLabel',
}))`
  color: #4A4A4A;
  font-size: 14px;
  font-weight: bold;
  line-height: 18px;
  margin-bottom: 6px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  ${({ theme }) => theme.breakPoints.tablet} {
    font-size: 16px;
  }
`;

export const CharCount = styled.div.attrs(() => ({
  className: 'StylesAddDirectorCharCount',
}))`
  color: ${({ theme }) => theme.colors.shadeMedium};
  font-size: 12px;
  font-weight: normal;
`;

export const PhotoUploaderContainer = styled.div<any>`
  color: ${({ theme }) => theme.colors.darkGray};
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  margin: 30px auto;

  .legoAvatarPhoto {
    width: 120px;
    height: 120px;
  }
  .legoAvatarSkeleton {
    margin-top: 5px;
    padding: 0;
  }
`;

export const ErrorMessage = styled.div.attrs(() => ({
  className: 'StylesAddDirectorError',
}))`
  color: #ef4b48;
  font-size: 14px;
  font-weight: normal;
  margin-bottom: 20px;
  margin-top: 5px;
`;

export const TextInput = styled(Texter)`
  > input {
    height: 40px;
    width: 100%;

    border: 1px solid ${({ theme }) => theme.colors.shadeMedium};
    border-radius: 8px;
    color: ${({ theme }) => theme.colors.shadeMediumDark} !important;
    font-size: 16px !important;
    font-weight: normal;
    line-height: 16px;
    padding: 0 0 0 12px;

    &:focus {
      border: 1px solid ${({ theme }) => theme.colors.physicalLight30};
    }
  }
`;

export const BtnWrapper = styled.div.attrs(() => ({
  className: 'StylesAddDirectorButtons',
}))`
  display: flex;
  justify-content: flex-end;
`;

export const NextBtn = styled(Button).attrs(() => ({
  className: 'StylesAddDirectorNext',
}))`
  width: 120px;
`;

export const Footer = styled.div.attrs(() => ({
  className: 'StylesAddDirectorFooter',
}))`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  grid-template-columns: max-content max-content;
  grid-template-areas: 'PreviousButton nextButton';
  box-sizing: border-box;
  width: 100%;
  border-top: 1px solid #dde4ea;
  padding: 10px 0 5px 0;

  .PreviousButton {
    grid-area: PreviousButton;
  }
  .NextButton {
    grid-area: NextButton;
  }
`;

export const PermissionList = styled.div.attrs(() => ({
  className: 'AddDirectorDefaultPermissionList',
}))`
  ${({ theme }) => theme.breakPoints.tablet} {
    height: 150px;
    overflow-y: scroll;
  }
`;

export const PermissionItem = styled.div.attrs(() => ({
  className: 'AddDirectorDefaultPermissionItem',
}))`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 16px;
`;

export const PermissionTitle = styled.h4.attrs(() => ({
  className: 'AddDirectorDefaultPermissionTitle',
}))`
  color: #4A4A4A;
  font-size: 16px;
  font-weight: bold;
  line-height: 21px;
  margin: 0;
  margin-bottom: 4px;
`;

export const PermissionText = styled.div.attrs(() => ({
  className: 'AddDirectorDefaultPermissionText',
}))`
  color: ${({ theme }) => theme.colors.shadeDark};
  font-size: 14px;
  font-weight: normal;
  line-height: 18px;
  margin: 0;
  margin-right: 10px;
`;

export const StyledSelecter = styled.div.attrs(() => ({
  className: 'AddDirectorStyledSelecter',
}))`
  flex: 1;
  width: 100%;

  .centerOptioner {
    margin: 0 10px 10px 16px;
  }

  .Selecter {
    .Select-placeholder {
      display: block!important;
      font-size: 16px;
      color: ${({ theme }) => theme.colors.shadeMediumDark};
      letter-spacing: -0.5px;
      line-height: 20.8px;
      padding-left: 16px;
    }
  }
`;
